import { render, staticRenderFns } from "./CreateTaxPph22.vue?vue&type=template&id=fc9625be"
import script from "./CreateTaxPph22.vue?vue&type=script&lang=js"
export * from "./CreateTaxPph22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports